import React, { useEffect, useState } from 'react';
import { Modal } from 'antd';
import { Routes, Route, useNavigate } from 'react-router-dom';
import RoomList from './RoomList';
import RoomDetail from './RoomDetail';
import { useRoomSocket } from '@src/pages/VisualActivation/hooks/useRoomSocket';
import { useGetJwtToken } from '@src/pages/VisualActivation/api/query';
import { useInitialInfoStore } from '@src/emp-3.0/store/useInitialInfo';
import { useConnectionData } from './store';
import { SOCKET_EVENTS } from './constant';

const VisualActivation: React.FC = () => {
  const { userInfo, workbenchMode } = useInitialInfoStore();
  const { data: jwtToken } = useGetJwtToken(userInfo?.api_key, userInfo?.username);
  const { connected, error, sendMessage, disconnect } = useRoomSocket(jwtToken?.token);
  const { reset, socket } = useConnectionData();
  const navigate = useNavigate();

  const [connectError, setConnectError] = useState<{
    type: 'force_disconnect' | 'app_client_exit';
  } | null>(null);

  useEffect(() => {
    if (workbenchMode) {
      navigate('/home'); // Redirect to home if workbench mode is enabled
    }
  }, [workbenchMode, navigate]);

  useEffect(() => {
    return () => {
      reset();
    };
  }, []);

  useEffect(() => {
    const handleAppClientExit = () => {
      setConnectError({ type: 'force_disconnect' });
      disconnect();
    };

    socket?.on(SOCKET_EVENTS.FORCE_DISCONNECT, handleAppClientExit);
    return () => {
      socket?.off(SOCKET_EVENTS.FORCE_DISCONNECT, handleAppClientExit);
    };
  }, [socket, disconnect]);

  const onRefresh = () => {
    window.location.reload();
  };

  return (
    <>
      <Routes>
        <Route
          path="/"
          element={<RoomList connected={connected} error={error} sendMessage={sendMessage} />}
        />
        <Route
          path="/room"
          element={<RoomDetail connected={connected} error={error} sendMessage={sendMessage} />}
        />
      </Routes>
      <Modal
        title="Connection Lost"
        open={!!connectError}
        closable={false}
        onOk={onRefresh}
        okText="Refresh"
        cancelButtonProps={{
          style: {
            display: 'none',
          },
        }}
      >
        <p>Your connection has been lost. Please refresh the page to reconnect.</p>
      </Modal>
    </>
  );
};

export default VisualActivation;
